pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.promo_claims = {
	
	init: function(){

		let html = '';

		$.ajax({

			url: endpoint+'/cms/zones/62/objects',
			method: 'get'

		}).done( r => {

			$.each( r, (k, i) => {

				if( this.hpurl ){

					html += 

					`<div class="col-sm-4 claim">
						<a href="${ this.hpurl || '#' }">
							${ i.hptitle }
						</a>
					</div>`;

				}else{

					html += 

					`<div class="col-sm-4 claim">
						${ i.hptitle }
					</div>`;

				}		

			})

			$('#promo-claims').html( html );

		})

	}
	
}